import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
    promptId: '',
    prompt: '',
    chatRoomId: '',
    model: ''
};

const promptSendMessageSlice = createSlice({
    name: 'promptSendMessageData',
    initialState,
    reducers: {
        setPromptSendMessageData(state, action: PayloadAction<any>) {
            return { ...state, ...action.payload };
        }
    }
});

export const { setPromptSendMessageData } = promptSendMessageSlice.actions;

export default promptSendMessageSlice.reducer;
